<template>
  <div class="vip" :style="vipStyle">
    <div class="vip-content">
      <avue-data-pay :option="option"></avue-data-pay>
    </div>
  </div>
</template>

<script>
import {list} from "../const/config";

export default {
  data() {
    return {
      sliderVisible: true, // 控制slider的显示
      notice: {},
      pay: "/images/pay.png",
      option: {
        span: 8,
        data: [
          {
            title: "BladeX 数据大屏版",
            src: "images/vip4.png",
            dismoney: "5999",
            tip: "/永久",
            color: "#5458d3",
            subtext: "购买",
            click: () => {
              this.alert(5);
              //this.box2 = true;
            },
            list: [
              {
                title: "BladeX数据大屏平台商业授权包含以下产品功能",
                check: true
              },
              {
                title: "包含Avue-Data大屏前端Vue2版源码",
                check: true
              },
              {
                title: "包含Avue-Data大屏前端Vue3版源码",
                check: true
              },
              {
                title: "包含无缝对接的Java后端Cloud版源码",
                check: true
              },
              {
                title: "包含无缝对接的Java后端Boot版源码",
                check: true
              },
              {
                title: "零代码拖拽配置",
                check: true
              },
              {
                title: "图形化编辑界面",
                check: true
              },
              {
                title: "多渠道数据对接",
                check: true
              },
              {
                title: "组件自定义拓展",
                check: true
              },
              {
                title: "单个导出独立部署",
                check: true
              },
              {
                title: "提供大屏配套文档",
                check: true
              },
              {
                title: "前后端源码全部提供",
                check: true
              },
              {
                title: "后续版本更新免费获取",
                check: true
              },
              {
                title: "提供发票与商业授权书",
                href: "/#/doc/biz-license",
                check: true
              },
              {
                title: "数据大屏系统演示请点击查看",
                href: "https://data.bladex.cn",
                check: true
              },
              {
                title: "不包含BladeX企业版功能",
                check: false
              },
              {
                title: "不包含应用市场第三方插件",
                check: false
              },
              {
                title: "暂不支持补差价升级至联合版",
                check: false
              },
            ]
          },
          {
            title: "BladeX 企业版",
            src: "images/vip3.png",
            color: "#ef4868",
            dismoney: "5000",
            tip: "/永久",
            subtext: "购买",
            click: () => {
              this.alert(1);
              //this.box2 = true;
            },
            list: [
              {
                title: "BladeX微服务开发平台商业授权包含以下产品功能",
                check: true
              },
              {
                title: "BladeX: 基于 SpringCloud2023 深度定制的微服务快速开发框架",
                check: true
              },
              {
                title: "BladeX-Boot: BladeX 的单体版本,助力中小型系统快速开发",
                check: true
              },
              {
                title: "BladeX-Tool: 微服务底层核心封装,业务与架构分离,快速插拔",
                check: true
              },
              {
                title: "Saber: 基于Vue2、Avue2、ElementUI开发的 BladeX 前端架构",
                check: true
              },
              {
                title: "Saber3: 基于Vue3、Avue3、ElementPlus开发的 BladeX 前端架构",
                check: true
              },
              {
                title: "Archer: 独立的代码生成系统,在线配置代码模版,在线生成代码",
                check: true
              },
              {
                title: "Rider: 基于 UniApp 封装的移动端跨平台开发框架",
                check: true
              },
              {
                title: "基于SpringBoot3、SpringCloud2023、JDK17",
                check: true
              },
              {
                title: "分布式架构与单体架构后端API完全一致",
                check: true
              },
              {
                title: "两套前端均可与任一后端架构无缝对接",
                check: true
              },
              {
                title: "数据库支持MySql、Oracle、PostgreSQL、SqlServer、达梦、崖山",
                check: true
              },
              {
                title: "基于OAuth2认证协议的单点登录系统",
                check: true
              },
              {
                title: "认证模块全系采用国密算法",
                check: true
              },
              {
                title: "支持灰度服务的发布与调用",
                check: true
              },
              {
                title: "支持Prometheus监控，系统安全一目了然",
                check: true
              },
              {
                title: "微服务上下线监控，集成钉钉告警",
                check: true
              },
              {
                title: "符合中国式需求的完整SaaS多租户架构方案",
                check: true
              },
              {
                title: "支持数据库与租户一对一、一对多、多对多等灵活模式",
                check: true
              },
              {
                title: "多租户数据库隔离支持分库分表在线配置",
                check: true
              },
              {
                title: "多租户顶部菜单自定义配置",
                check: true
              },
              {
                title: "在线配置，直接生效的动态数据、接口权限",
                check: true
              },
              {
                title: "API报文全局加密机制，增强系统安全等级",
                check: true
              },
              {
                title: "集成7.x版本Elk，支持分布式日志追踪",
                check: true,
              },
              {
                title: "支持分布式场景的Flowable工作流",
                check: true
              },
              {
                title: "高性能报表引擎，可以实现任意复杂的中国式报表",
                check: true
              },
              {
                title: "集成七牛、阿里云、腾讯云、minio等对象存储",
                check: true
              },
              {
                title: "集成七牛、阿里云、腾讯云、云片等短信服务",
                check: true
              },
              {
                title: "集成Kafka、Rabbit、Cloud-Stream等消息队列",
                check: true
              },
              {
                title: "基于Nacos的轻量级、高拓展性动态网关",
                check: true
              },
              {
                title: "完美集成Dubbo最新版，支持RPC远程调用",
                check: true
              },
              {
                title: "集成XxlJob、PowerJob，支持分布式任务调度",
                check: true
              },
              {
                title: "提供PowerJob客户端系统内部调用",
                check: true
              },
              {
                title: "提供开发平台配套文档",
                check: true
              },
              {
                title: "前后端工程源码全部提供",
                check: true
              },
              {
                title: "额外赠送流程设计器插件编译版lib包",
                check: true
              },
              {
                title: "额外赠送表单设计器插件编译版lib包",
                check: true
              },
              {
                title: "后续版本更新免费获取",
                check: true
              },
              {
                title: "提供发票与商业授权书",
                href: "/#/doc/biz-license",
                check: true
              },
              {
                title: "更多核心功能请点击查看",
                href: "/#/doc/biz-list",
                check: true
              },
              {
                title: "购买后便可前往应用市场选购插件",
                href: "/#/market",
                check: true
              },
              {
                title: "不包含BladeX数据大屏版功能",
                check: false
              },
              {
                title: "不包含应用市场第三方插件",
                check: false
              },
              {
                title: "暂不支持补差价升级至联合版",
                check: false
              },
            ]
          },
          {
            title: "BladeX 物联网平台",
            src: "images/vip1.png",
            color: "#000000",
            money: '9999',
            dismoney: "8999",
            tip: "/永久",
            subtext: "前往",
            click: () => {
              window.open("https://iot.bladex.cn/license.html");
            },
            list: [
              {
                title: "BladeX物联网开发平台商业授权包含以下产品功能",
                check: true
              },
              {
                title: "BladeX-Links: BladeX物联网平台后端工程",
                check: true
              },
              {
                title: "BladeX-Links-UI: BladeX物联网平台Vue3前端工程",
                check: true
              },
              {
                title: "node-red-pro: 为BladeX物联网平台量身定制的物联网边缘网关",
                check: true
              },
              {
                title: "mica-mqttx: 物联网底层组件商业版工程,自研MQTT高性能服务器",
                check: true
              },
              {
                title: "基于SpringBoot3、SpringCloud2023、JDK17",
                check: true
              },
              {
                title: "可无缝集成至BladeX企业版架构",
                check: true
              },
              {
                title: "时序库支持：InfluxDB、InfluxDB2、IotDB、TDEngine",
                check: true
              },
              {
                title: "MQTT自研服务端,交付源码可二开,无需借助其他服务端便可独立启动",
                check: true
              },
              {
                title: "MQTT与AMQP转发",
                check: true
              },
              {
                title: "规则引擎与边缘网关",
                check: true
              },
              {
                title: "多渠道告警通知",
                check: true
              },
              {
                title: "协议转换与数据解析",
                check: true
              },
              {
                title: "品类管理",
                check: true
              },
              {
                title: "分组管理",
                check: true
              },
              {
                title: "产品管理",
                check: true
              },
              {
                title: "物模型管理",
                check: true
              },
              {
                title: "版本快照与回退",
                check: true
              },
              {
                title: "设备管理",
                check: true
              },
              {
                title: "设备模拟器",
                check: true
              },
              {
                title: "设备调试器",
                check: true
              },
              {
                title: "前后端源码全部提供",
                check: true
              },
              {
                title: "后续版本更新免费获取",
                check: true
              },
              {
                title: "提供发票与商业授权书",
                href: "/#/doc/biz-license",
                check: true
              },
            ]
          },
          {
            title: "BladeX 联合版",
            src: "images/vip2.png",
            color: "#ffa820",
            money: '10999',
            dismoney: "8999",
            tip: "/永久",
            subtext: "购买",
            click: () => {
              this.alert(3);
              //this.box2 = true;
            },
            list: [
              {
                title: "此版本为BladeXAvue的联合授权",
                check: true
              },
              {
                title: "企业版与数据大屏打包购买享受超值折扣",
                check: true
              },
              {
                title: "原价 ¥10999 现打包购买仅需 ¥8999",
                check: true
              },
              {
                title: "包含BladeX数据大屏版所有功能",
                check: true
              },
              {
                title: "包含BladeX企业版所有功能",
                check: true
              },
              {
                title: "后续版本更新免费获取",
                check: true
              },
              {
                title: "提供发票与商业授权书",
                href: "/#/doc/biz-license",
                check: true
              },
              {
                title: "购买后便可前往应用市场选购插件",
                href: "/#/market",
                check: true
              },
            ]
          },
        ]
      },
      list: list
    };
  },
  computed: {
    vipStyle() {
      // 根据 sliderVisible 状态返回不同的 padding
      return this.sliderVisible
        ? { paddingTop: '80px' } // 默认 padding
        : { paddingTop: '200px' }; // slider 隐藏时的 padding
    },
  },
  created() {
    setTimeout(() => {
      this.notice = this.$notify.success({
        title: "BladeX 新产品通知",
        dangerouslyUseHTMLString: true,
        message: `
        <p>----------------------------</p>
        <p>《BladeXAI大模型平台》正式发售通知</p>
        <p>----------------------------</p>
        <p>1.「三位一体」智能架构提供灵活的 Chat、Agent、RAG 模式，满足不同业务需求，让智能化升级触手可及。</p>
        <p>2. 老用户购买额外优惠：￥2,000元。</p>
        <p>3. 系统演示：<a target="_blank" href="https://aigc.bladex.cn/">查看演示</a></p>
        <p>4. 官网地址：很快到来，敬请期待。</p>
        <p>5. 商务联系：<a target="_blank" href="https://bladex.cn/#/contract">点击查看</a></p>
        <p>----------------------------</p>
        <p>《BladeX物联网平台》正式发售通知</p>
        <p>----------------------------</p>
        <p>1.「纯自研MQTT」「EMQX+Kafka」双架构，支持单机与集群双模式切换，满足不同业务场景，助力万物互联。</p>
        <p>2. 老用户购买额外优惠：￥2,000元。</p>
        <p>3. 系统演示：<a target="_blank" href="https://iot.javablade.com/">查看演示</a></p>
        <p>4. 官网地址：<a target="_blank" href="https://iot.bladex.cn/">查看官网</a></p>
        <p>5. 商务联系：<a target="_blank" href="https://bladex.cn/#/contract">点击查看</a></p>
        <p>----------------------------</p>`,
        duration: 0,
        offset: 50,
        position: 'bottom-right',
        type: "success"
      });
    }, 500);

    const handleResize = () => {
      this.sliderVisible = window.innerWidth > 768;
    };
    handleResize(); // 确保首次加载时执行
    window.addEventListener('resize', () => {
      this.sliderVisible = window.innerWidth > 768;
      this.$forceUpdate(); // 强制更新视图
    });
  },
  destroyed() {
    this.notice.close();
  },
  methods: {
    alert(version) {
      this.$router.push({
        path: '/pay',
        query: {
          version: version
        }
      })
    }
  }
};
</script>

<style lang="scss">
.vip {

  &-box {
    padding-top: 10px;
  }

  &-content {
    margin: 10px auto;
    width: 85%;
  }

  .title {
    margin-top: 10px;
    text-align: center;
  }

  .avue-data-pay {
    padding-bottom: 30px;
  }

  .avue-data-pay .item {
    width: 90%;
    min-height: 300px;
  }

  .avue-data-pay .list-item {
    margin-bottom: 7px;
    font-size: 12px;
    padding: 0 20px;
    line-height: 25px;

    a {
      color: #515a6e;
    }
  }

  .avue-data-pay .list-item--no + a > span {
    color: #da5a5a;
  }
}

</style>
